import * as reportApi from '../../api/reportApi'

const state = {
	reportOutput: {
		AmountTotal: null,
		OrderTotal: null,
		RepairAmountTotal: null,
		RepairOrderTotal: null
	}
}

const actions = {
	//测试商家报表接口
	async getMerchantReport({
		commit
	}, param) {
		const response = await reportApi.getMerchantReport(param)
		commit('setMerchantReport', response)
	},
	//测试门店报表接口
	async getStoreReport({
		commit
	}, param) {
		const response = await reportApi.getStoreReport(param)
		commit('setStoreReport', response)
	},
	//测试维修师报表接口
	async getRepairmanReport({
		commit
	}, param) {
		const response = await reportApi.getRepairmanReport(param)
		commit('setRepairmanReport', response)
	},
	//正式接口
	async getReportData({
		commit
	}, param) {
		const response = await reportApi.getReportData(param)
		commit('setReportData', response)
	}
}

const mutations = {
	//测试商家报表接口
	setMerchantReport(state, res) {
		state.reportOutput = res.Data
	},
	//测试门店报表接口
	setStoreReport(state, res) {
		state.reportOutput = res.Data
	},
	//测试维修师报表接口
	setRepairmanReport(state, res) {
		state.reportOutput = res.Data
	},
	//正式接口
	setReportData(state, res) {
		state.reportOutput = res.Data
	}
}

export default {
	namespaced: true,
	state,
	actions,
	mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/report.js